exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* override default */\n.sidebar-menu > li > a {\n  padding: 7px 15px 7px 15px;\n  display: flex;\n  align-items: center;\n}\n.sidebar-menu li.active > a > .fa-angle-left,\n.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {\n  animation-name: rotate;\n  animation-duration: 0.2s;\n  animation-fill-mode: forwards;\n}\n.sidebar-menu > li svg {\n  width: 15px;\n  height: auto;\n  margin-right: 5px;\n}\n@keyframes rotate {\n0% {\n    transform: rotate(0deg);\n}\n100% {\n    transform: rotate(-90deg);\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-84891178","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/main/SidebarMenu.vue
// module id = 215
// module chunks = 0